import Script from 'next/script';
import React from 'react';

export const OneTrustScript: React.FC = () => (
  <>
    <Script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `
  window.__promiseHooks = {};

  window.__promiseHooks.oneTrustLoaderPromise = new Promise((res, rej) => {
    window.jsonFeed = res;
  });

  window.__promiseHooks.optimizelyLoaderPromise = new Promise((res, rej) => {
    __promiseHooks.optimizelyLoaderPromiseResolve = res;
  });
`,
      }}
    />
    <Script
      id="one-trust"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{
        __html: `
      const ONE_TRUST_IDS = {
        'members.onepeloton.ca': 'a2894ea0-c886-494c-bbe5-28adbf4e511e',
        'members.onepeloton.co.uk': 'd0b182b9-37ba-4d24-aec9-561016f5b2cd',
        'members.onepeloton.com': 'f5dff851-eaff-42d2-82e8-a626e78504c6',
        'members.onepeloton.com.au': '6176b1cd-f1cb-4b40-865d-f3cd1a74d590',
        'members.onepeloton.de': '7cc03490-8b5a-42f1-ad79-19a14a986dc6',
        'members.onepeloton.at': '27321c3d-eae2-4f3b-ada9-0cd6d50b63d3',
        'members.test.onepeloton.ca': 'a2894ea0-c886-494c-bbe5-28adbf4e511e-test',
        'members.test.onepeloton.co.uk': 'd0b182b9-37ba-4d24-aec9-561016f5b2cd-test',
        'members.test.onepeloton.com': 'f5dff851-eaff-42d2-82e8-a626e78504c6-test',
        'members.test.onepeloton.de': '7cc03490-8b5a-42f1-ad79-19a14a986dc6-test',
        'members.test.onepeloton.com.au': '6176b1cd-f1cb-4b40-865d-f3cd1a74d590-test',
        'members.test.onepeloton.at': '27321c3d-eae2-4f3b-ada9-0cd6d50b63d3-test',
        'members.uat.onepeloton.ca': 'a2894ea0-c886-494c-bbe5-28adbf4e511e-test',
        'members.uat.onepeloton.co.uk': 'd0b182b9-37ba-4d24-aec9-561016f5b2cd-test',
        'members.uat.onepeloton.com': 'f5dff851-eaff-42d2-82e8-a626e78504c6-test',
        'members.uat.onepeloton.de': '7cc03490-8b5a-42f1-ad79-19a14a986dc6-test',
        'members.uat.onepeloton.com.au': '6176b1cd-f1cb-4b40-865d-f3cd1a74d590-test',
        'members.uat.onepeloton.at': '27321c3d-eae2-4f3b-ada9-0cd6d50b63d3-test',
        'local-members.onepeloton.ca': 'a2894ea0-c886-494c-bbe5-28adbf4e511e-test',
        'local-members.onepeloton.co.uk': 'd0b182b9-37ba-4d24-aec9-561016f5b2cd-test',
        'local-members.onepeloton.com': 'f5dff851-eaff-42d2-82e8-a626e78504c6-test',
        'local-members.onepeloton.de': '7cc03490-8b5a-42f1-ad79-19a14a986dc6-test',
        'local-members.onepeloton.com.au': '6176b1cd-f1cb-4b40-865d-f3cd1a74d590-test',
        'local-members.onepeloton.at': '27321c3d-eae2-4f3b-ada9-0cd6d50b63d3-test',
        'dev-members.onepeloton.com': 'f5dff851-eaff-42d2-82e8-a626e78504c6-test'
      };

      const writeOneTrustOtAutoBlockStub = oneTrustID => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://cdn.cookielaw.org/consent/' + oneTrustID + '/OtAutoBlock.js';
        document.head.appendChild(script);
      };

      const writeOneTrustOtSDKStub = oneTrustID => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = false;
        script.charset = 'UTF-8';
        script.setAttribute('data-domain-script', oneTrustID);
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        document.head.appendChild(script);
      };

      const writeOptanonWrapperScript = () => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.text = 'function OptanonWrapper() {}';
        document.head.appendChild(script);
      };

      let hasInitiatedScripts = false;
      const buildOneTrustScripts = () => {
        const isCypressTest = !!window.Cypress;

        if (isCypressTest) return;

        const oneTrustID =
          ONE_TRUST_IDS[window.location.hostname] ||
          ONE_TRUST_IDS[
            Object.keys(ONE_TRUST_IDS).find(id => window.location.hostname.endsWith(id))
          ]; //Applies test env key to deployment previews
        const envHasOneTrustID = Boolean(oneTrustID && oneTrustID.trim());

        if (envHasOneTrustID && !hasInitiatedScripts) {
          hasInitiatedScripts = true;
          writeOneTrustOtAutoBlockStub(oneTrustID);
          writeOneTrustOtSDKStub(oneTrustID);
          writeOptanonWrapperScript();
        }
      };

      window.buildOneTrustScripts = buildOneTrustScripts;`,
      }}
    />
  </>
);
